<template>
    <div>
        <rkm-table
            :items="unidades"
            :fields="fields"
            sort-by="nomeFantasia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="secondary"
                    small
                    title="Percentual da cota por mês"
                    @click="abrirModal(item)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalPercentualMensal ref="ModalPercentualMensal" />
    </div>
</template>

<script>
import ModalPercentualMensal from '../ModalPercentualMensal'

export default {
    components: { ModalPercentualMensal },

    props: {
        unidades: { required: true, type: Array },
    },

    computed: {
        fields() {
            return [
                { key: 'nomeFantasia', label: 'Unidade solicitante', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },

    methods: {
        abrirModal(item) {
            const local = [item.nomeFantasia, item.infraestruturaNome].filter(Boolean).join(' / ')

            this.$refs.ModalPercentualMensal.open(item, `App ConectaSUS - Cidadão ${local}`)
        },
    },
}
</script>
